module.exports = __webpack_public_path__ + "static/media/apng_lola.269cb56c.png";